import React, { Component } from 'react';
import { acessoPermitido } from '../../../acessos.seguranca';
import RequisicaoCongelacaoPage from './requisicao.congelacao.page';
import WebapiCommon from '../util/webapi.common';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as blocoActions from './tabs/bloco/bloco.action';
import * as laminaActions from './tabs/lamina/lamina.action';
import * as commonActions from '@common/common.action';
import { getUsuarioLocalStorage } from '../../../localStorage.util';
import LaminaApi from './tabs/lamina/lamina.api';

class ProtocoloContainer extends Component {
  constructor(props) {
    super(props);
    this.selectAnticorposRef = React.createRef();
    this.state = {
      listagemBlocos: [],
      listagemGrupoAnticorpos: [],
      blocoSelecionado: undefined,
      grupoAnticorposSelecionado: undefined,
      listaAnticorposFiltro: [],
      material: undefined,
      frasco: undefined,
      numeroExame: null,
      numeroExameExterno: null,
      listarLaminas: [],
      reagentesSelecionados: [],
      reagentesCadastrados: [],
      laudo: props.laudo,
      laudoAnterior: null,
      medicos: [],
      medicoselecionado: null,
      novosregistros: [],
      modalAnticorpoJaLancado: {
        show: false,
      },
      showModalJustificativa: false,
      justificativa: '',
      idLaudoLamina: null,
    };
  }

  apagarLaminaJustificativa(id) {
    this.setState({
      showModalJustificativa: true,
      idLaudoLamina: id,
    });
  }

  toggleModalJustificativa() {
    this.setState({
      showModalJustificativa: !this.state.showModalJustificativa,
      idLaudoLamina: null,
    });
  }

  setJustificativa(texto) {
    this.setState({
      justificativa: texto,
    });
  }

  editarLamina(id) {
    this.props.laminaActions.alterarTab('1');
    this.props.laminaActions.alterarLaminaText('Editar lâmina');
    this.props.laminaActions.alterarLaminaId(id);
    this.props.laminaActions.carregarEdicao(true);
    this.toggle('1');
  }

  render() {
    const formatGroupLabel = (data) => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <span
          onClick={() => this.selecionarAnticorposPorGrupo(data.label)}
          style={{
            fontSize: 11,
            fontWeight: 600,
            color: '#000',
          }}
        >
          {data.label}
        </span>
      </div>
    );

    return (
      <RequisicaoCongelacaoPage
        resetEditar={this.resetEditar.bind(this)}
        laminaText={this.props.laminaText}
        laminaId={this.props.laminaId}
        editarLamina={this.editarLamina.bind(this)}
        laudo={this.state.laudo}
        usuario={this.props.usuario}
        acessoPermitido={acessoPermitido}
        listarLaminas={this.props.listarLaminas} //Lamina
        listagemBlocos={this.state.listagemBlocos}
        listagemProtocolos={this.state.listagemProtocolos}
        listaAnticorposFiltro={this.state.listaAnticorposFiltro}
        formatGroupLabel={formatGroupLabel}
        bloco={this.state.blocoSelecionado}
        grupo={this.state.grupoAnticorposSelecionado}
        listagemGrupoAnticorpos={this.state.listagemGrupoAnticorpos}
        material={this.state.material}
        frasco={this.state.frasco}
        numeroExame={this.state.numeroExame}
        numeroExameExterno={this.state.numeroExameExterno}
        laudoAnterior={this.state.laudoAnterior}
        reagentesSelecionados={this.state.reagentesSelecionados}
        reagentesCadastrados={this.state.reagentesCadastrados}
        removerAnticorposLista={this.removerAnticorposLista.bind(this)}
        removerLaminaLista={this.removerLaminaLista.bind(this)}
        selecaoBloco={this.selecaoBloco.bind(this)}
        selecaoAnticorposPorGrupo={this.selecaoAnticorposPorGrupo.bind(this)}
        selecaoProtocolo={this.selecaoProtocolo.bind(this)}
        selecaoProtocoloBefore={this.selecaoProtocoloBefore.bind(this)}
        adicionarRequisicaoProtocolo={this.adicionarRequisicaoProtocolo.bind(
          this
        )}
        selectAnticorposRef={this.selectAnticorposRef}
        medicos={this.state.medicos}
        medicoselecionado={this.state.medicoselecionado}
        stateUpdate={this.stateUpdate.bind(this)}
        limparAnticorposSelecionados={this.limparAnticorposSelecionados.bind(
          this
        )}
        activeTab={this.props.activeTab}
        toggle={this.toggle.bind(this)}
        novosregistros={this.state.novosregistros}
        modalAnticorpoJaLancado={this.state.modalAnticorpoJaLancado}
        toggleModalAnticorpoJaLancado={this.toggleModalAnticorpoJaLancado.bind(
          this
        )}
        showModalJustificativa={this.state.showModalJustificativa}
        justificativa={this.state.justificativa}
        setJustificativa={this.setJustificativa.bind(this)}
        toggleModalJustificativa={this.toggleModalJustificativa.bind(this)}
        apagarLaminaJustificativa={this.apagarLaminaJustificativa.bind(this)}
      />
    );
  }

  sortJSON(arr, key, way) {
    return arr.sort((a, b) => {
      let x = a[key];
      let y = b[key];
      let result;
      if (way === 'asc') {
        result = x < y ? -1 : x > y ? 1 : 0;
      }
      if (way === 'desc') {
        result = x > y ? -1 : x < y ? 1 : 0;
      }
      return result;
    });
  }

  componentWillMount() {
    let laudo = this.props.laudo;
    this.props.commonActions.showFadeCarregando(true);
    Promise.all([
      WebapiCommon.dadosTelaRequisicaoAnticorpos(laudo),
      WebapiCommon.getAnticorpos(),
      WebapiCommon.getMedicos(),
      LaminaApi.getListagemLaminas(laudo),
    ]).then((response) => {
      let dadosTelaRequisicaoAnticorposResponse = response[0];
      let getAnticorposResponse = response[1];
      let getMedicosResponse = response[2];

      const getLaminasCongelacaoResponse = this.sortJSON(
        response[3],
        'lamina',
        'asc'
      );

      if (getLaminasCongelacaoResponse) {
        this.props.laminaActions.atualizarListagemLaminas(
          getLaminasCongelacaoResponse
        );
      }

      let dadosExameRequisicaoAnticorpos =
        dadosTelaRequisicaoAnticorposResponse.data
          .dadosExameRequisicaoAnticorpos;
      let blocoParaRequisicaoAnticorpos =
        dadosTelaRequisicaoAnticorposResponse.data
          .blocoParaRequisicaoAnticorpos;

      let listagemBlocos = blocoParaRequisicaoAnticorpos.map((el) => ({
        value: el.idLaudoBloco,
        label: el.bloco,
        material: el.material,
        frasco: el.frasco,
      }));

      let listagemProtocolos = [];
      let listagemGrupos = [];
      getAnticorposResponse.data.forEach((el) => {
        let item = listagemProtocolos.find((e) => e.label === el.tipo);
        if (item) {
          item.options.push({
            value: el.value,
            label: el.label,
            tipo: el.tipo,
          });
        } else {
          if (el.tipo != null)
            listagemGrupos.push({ value: el.value, label: el.tipo });
          listagemProtocolos.push({
            label: el.tipo,
            options: [
              {
                value: el.value,
                label: el.label,
                tipo: el.tipo,
              },
            ],
          });
        }
      });

      let usuarioLocalStorage = getUsuarioLocalStorage();
      let medicoselecionado = null;

      if (usuarioLocalStorage) {
        medicoselecionado = {
          value: usuarioLocalStorage.medicoId,
          label:
            usuarioLocalStorage.medicoId + ' - ' + usuarioLocalStorage.medico,
        };
      }

      this.setState({
        laudo: this.props.laudo,
        numeroExame: dadosExameRequisicaoAnticorpos.nrExame,
        listagemBlocos: listagemBlocos,
        numeroExameExterno: dadosExameRequisicaoAnticorpos.nrExameExterno,
        laudoAnterior: dadosExameRequisicaoAnticorpos.laudoAnterior,
        listagemProtocolos: listagemProtocolos,
        medicos: getMedicosResponse,
        medicoselecionado,
        listagemGrupoAnticorpos: listagemGrupos,
      });

      this.props.commonActions.showFadeCarregando(false);
    });
  }

  componentDidUpdate(props) {
    if (this.props.carregarLaminas) {
      Promise.all([LaminaApi.getListagemLaminas(this.props.laudo)]).then(
        (response) => {
          const getLaminasCongelacaoResponse = this.sortJSON(
            response[0],
            'lamina',
            'asc'
          );

          if (getLaminasCongelacaoResponse) {
            this.props.laminaActions.atualizarListagemLaminas(
              getLaminasCongelacaoResponse
            );
          }
        }
      );
      this.props.laminaActions.carregarLaminas(false);
    }
  }

  resetEditar = () => {
    this.toggle('2');
    this.props.laminaActions.carregarLaminas(false);
    this.props.laminaActions.alterarLaminaText('Adicionar lâmina');
    this.props.laminaActions.alterarLaminaId(null);
    this.props.laminaActions.alterarEdicao(false);
  };

  getReagentesCadastrados(getLaminasImunoResponse) {
    return getLaminasImunoResponse.map((lamina) => ({
      id: lamina.cdRequisicao,
      nome: lamina.medId + ' - ' + lamina.nome,
      bloco: lamina.nrBloco,
      lamina: lamina.dsCasoLamina,
      anticorpo: lamina.anticorpo,
      cdAnticorpo: lamina.cdAnticorpo,
      tipo: lamina.tipo,
    }));
  }

  selecaoBloco(bloco) {
    this.setState({
      material: bloco.material,
      frasco: bloco.frasco,
      blocoSelecionado: bloco,
    });
  }

  selecaoAnticorposPorGrupo(grupo) {
    let item = this.state.listagemProtocolos.find(
      (e) => e.label === grupo.label
    );

    this.setState({
      grupoAnticorposSelecionado: grupo,
      listaAnticorposFiltro: item,
    });
  }

  removerAnticorposLista(index) {
    let reagentes = this.state.reagentesSelecionados;
    reagentes.splice(index, 1);

    if (index > -1) {
      this.setState({
        reagentesSelecionados: reagentes,
      });
    }
  }

  removerLaminaLista() {
    const id = this.state.idLaudoLamina;
    const justificativa = this.state.justificativa;
    if (justificativa && id) {
      const laminas = this.props.listarLaminas;
      const laudo = this.props.laudo;
      const lista = [];

      if (id && laudo && laminas) {
        laminas.map((lamina) => {
          if (lamina.idLaudoLamina !== id) {
            lista.push(lamina);
          }
          return lista;
        });

        this.props.laminaActions.atualizarListagemLaminas(lista);
        this.props.commonActions.showFadeCarregando(true);
        LaminaApi.apagarLaminaCongelacao(laudo, id, justificativa)
          .then((res) => {
            this.props.commonActions.showFadeCarregando(false);
            if (res.success) {
              this.props.commonActions.showAlerta(
                'sucesso',
                res.message,
                2000,
                res.message.length * 10 + 'px'
              );
            }
          })
          .catch((err) => {
            console.log(err);
          });

        this.setState({ showModalJustificativa: false, justificativa: '' });
      }
    }
  }

  selecaoProtocoloBefore(protocolo) {
    let { reagentesCadastrados } = this.state;
    if (
      reagentesCadastrados.findIndex(
        (el) => el.cdAnticorpo === protocolo.value
      ) > -1
    ) {
      this.setState({
        modalAnticorpoJaLancado: {
          show: true,
          protocolo,
        },
      });
    } else {
      this.selecaoProtocolo(protocolo);
    }
  }

  selecaoProtocolo = (protocolo) =>
    this.setState((state) => ({
      reagentesSelecionados: [
        ...state.reagentesSelecionados,
        {
          bloco: state.blocoSelecionado,
          protocolo: protocolo,
        },
      ],
      modalAnticorpoJaLancado: {
        show: false,
      },
    }));

  selecionarAnticorposPorGrupo(grupo) {
    const { listagemProtocolos } = this.state;
    let anticorposDoGrupo = listagemProtocolos.find((el) => el.label === grupo);
    if (anticorposDoGrupo) {
      anticorposDoGrupo.options.forEach((el) => this.selecaoProtocolo(el));
      this.selectAnticorposRef.current.blur();
    }
  }

  adicionarRequisicaoProtocolo() {
    this.props.commonActions.showFadeCarregando(true);

    const {
      blocoSelecionado,
      laudo,
      medicoselecionado,
      reagentesSelecionados,
      reagentesCadastrados,
    } = this.state;

    let usuarioLocalStorage = getUsuarioLocalStorage();
    let laminas = reagentesSelecionados.map((el) => ({
      lamina: 'Imuno',
      qtd: 1,
      cdAnticorpo: el.protocolo.value,
    }));

    var criarLaminaRequest = {
      nrBloco: blocoSelecionado.label,
      blocoID: blocoSelecionado.value,
      laudoID: laudo,
      medicoID: medicoselecionado.value,
      tecnicoID: usuarioLocalStorage.usuarioId,
      sentinelaMama: false,
      sentinelaMelanoma: false,
      complemento: '',
      laminas: laminas,
    };

    WebapiCommon.criarLamina(criarLaminaRequest).then(() => {
      WebapiCommon.getLaminasImuno(laudo).then((laminas) => {
        let novosReagentesCadastrados = this.getReagentesCadastrados(laminas);
        let novosregistros = [...novosReagentesCadastrados];

        reagentesCadastrados.forEach((el) => {
          let posicao = novosregistros.findIndex((e) => e.id === el.id);
          if (posicao > -1) {
            novosregistros.splice(posicao, 1);
          }
        });

        this.setState({
          reagentesCadastrados: novosReagentesCadastrados,
          reagentesSelecionados: [],
          novosregistros,
        });

        this.toggle('2');
        this.props.commonActions.showAlerta(
          'sucesso',
          'Lâmina solicitada com sucesso',
          800
        );
        this.props.commonActions.showFadeCarregando(false);

        setTimeout(this.limparNovosRegistros, 4000);
      });
    });
  }

  stateUpdate = (name, value) =>
    this.setState({
      [name]: value,
    });

  limparAnticorposSelecionados = () =>
    this.setState({
      reagentesSelecionados: [],
    });

  toggle = (activeTab) => this.props.laminaActions.alterarTab(activeTab);

  limparNovosRegistros = () => this.setState({ novosregistros: [] });

  toggleModalAnticorpoJaLancado = () => {
    let { modalAnticorpoJaLancado } = this.state;
    modalAnticorpoJaLancado.show = !modalAnticorpoJaLancado.show;
    this.setState({ modalAnticorpoJaLancado });
  };
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario,
    carregando: state.commonReducer.showCarregando,
    mensagem: state.commonReducer.mensagemAlerta,
    timeout: state.commonReducer.timeoutAlerta,
    tipoAlerta: state.commonReducer.tipoAlerta,
    idAlerta: state.commonReducer.idAlerta,
    medicoPadrao: state.commonReducer.medicoPadraoMacroscopia,
    listarLaminas: state.laminaCongelacao.listarLaminas,
    modalBloco: state.blocoCongelacao.modalBloco,
    modalLamina: state.laminaCongelacao.modalLamina,
    carregarLaminas: state.laminaCongelacao.carregarLaminas,
    carregarBlocos: state.blocoCongelacao.carregarBlocos,
    laminaText: state.laminaCongelacao.laminaText,
    laminaId: state.laminaCongelacao.laminaId,
    activeTab: state.laminaCongelacao.activeTab,
  };
};

const mapsDispacthToProps = (dispatch) => {
  return {
    blocoActions: bindActionCreators(blocoActions, dispatch),
    laminaActions: bindActionCreators(laminaActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapsDispacthToProps
)(ProtocoloContainer);



// WEBPACK FOOTER //
// ./src/app/common/requisicaoCongelacao/requisicao.congelacao.container.js